import { render, staticRenderFns } from "./track.vue?vue&type=template&id=96fd8e06&"
import script from "./track.vue?vue&type=script&lang=js&"
export * from "./track.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports